<div class="flex items-center justify-center">
  <button
    *isAllowed="[ERoleAdminString.Admin, 'setup.create']"
    type="button"
    class="w-80 btn btn--secondary mr-5"
    (click)="formOpen = true"
  >
    Cadastrar Novo
  </button>
</div>

<app-dialog
  *ngIf="formOpen"
  heading="CADASTRAR NOVO SETUP"
  description="Insira os dados abaixo para cadastrar"
  (closed)="close()"
>
  <form class="flex flex-col gap-5" [formGroup]="formSetup">
    <div class="w-full flex flex-col md:flex-row gap-5 px-5">
      <div class="form-group">
        <input type="text" class="form-input" placeholder="Nome" formControlName="name" />
      </div>

      <div class="form-group" *isAllowed="[ERoleAdminString.Admin]">
        <ng-select
          notFoundText="Nenhum item encontrado"
          [searchable]="false"
          placeholder="Empresa"
          formControlName="companyId"
        >
          <ng-option *ngFor="let company of companies" [value]="company.id">
            {{ company.name }}
          </ng-option>
        </ng-select>
      </div>
    </div>

    <div class="w-full" *isAllowed="[ERoleAdminString.Admin, 'setup.create']" formGroupName="setupConfig">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-5 px-5">
        <div class="form-group">
          <ng-select
            notFoundText="Nenhum item encontrado"
            [searchable]="false"
            placeholder="Modulo para retornar ao terminar o fluxo."
            formControlName="home"
          >
            <ng-option *ngFor="let optionHome of homeModuleOptions" [value]="optionHome.id">
              {{ optionHome.name }}
            </ng-option>
          </ng-select>
        </div>

        <div class="form-group">
          <ng-select
            notFoundText="Nenhum item encontrado"
            [searchable]="false"
            placeholder="Usar Tema Customizado no App"
            formControlName="setupTheme"
          >
            <ng-option *ngFor="let theme of optionsTheme" [value]="theme.value">
              {{ theme.label }}
            </ng-option>
          </ng-select>
        </div>

        <div class="form-group">
          <label class="flex items-center gap-2 cursor-pointer">
            <span class="text-sm font-medium text-chathams-blue">Ativar verificação de pagamento</span>
            <input type="checkbox" formControlName="checkValidPayment" class="toggle-checkbox hidden" />
            <span class="toggle-switch"></span>
          </label>
        </div>

        <div class="form-group">
          <label class="flex items-center gap-2 cursor-pointer">
            <span class="text-sm font-medium text-chathams-blue">Utiliza fluxo de telemedicina?</span>
            <input type="checkbox" formControlName="hasTelemedicine" class="toggle-checkbox hidden" />
            <span class="toggle-switch"></span>
          </label>
        </div>

        <div class="form-group">
          <label class="flex items-center gap-2 cursor-pointer">
            <span class="text-sm font-medium text-chathams-blue">Acessibilidade por voz</span>
            <input type="checkbox" formControlName="accessibilityVoice" class="toggle-checkbox hidden" />
            <span class="toggle-switch"></span>
          </label>
        </div>
      </div>

      <div class="px-5 pb-5">
        <app-setup-identification
          [anonymousControl]="anonymousControl"
          [registrationGroup]="registrationGroup"
          [ageGenderModuleNames]="ageGenderModuleNames"
        ></app-setup-identification>
      </div>
    </div>

    <div class="grid grid-cols-3 gap-5 mx-5 border-t border-b py-5">
      <div class="col-span-2">
        <h3 class="font-bold text-chathams-blue mb-4">Módulos do Fluxo</h3>
        <div
          class="max-h-[300px] overflow-y-auto border rounded-lg p-2 bg-gray-50"
          cdkDropList
          [cdkDropListData]="modules"
          (cdkDropListDropped)="drop($event)"
        >
          <div *ngFor="let module of modules; let i = index" class="mb-2" cdkDrag>
            <div
              class="bg-white hover:bg-gray-50 p-3 flex items-center border justify-between border-iceberg rounded-md shadow-sm"
            >
              <div class="flex items-center">
                <mat-icon class="cursor-move text-gray-400 mr-2">drag_indicator</mat-icon>
                <span class="font-medium text-md text-chathams-blue">{{ i + 1 }}. {{ module.name }}</span>
                <mat-icon
                  *ngIf="hasUnmetDependencies(module)"
                  [matTooltip]="'Requer: ' + getMissingDependencyNames(module).join(', ')"
                  color="warn"
                  class="ml-1 animate-pulse"
                >
                  warning
                </mat-icon>
              </div>

              <div class="flex items-center gap-2">
                <button
                  *ngIf="hasConfig(module.configSchema)"
                  type="button"
                  (click)="openModuleSettingModal(module.id)"
                  mat-icon-button
                  color="primary"
                  class="text-cerise-red"
                  matTooltip="Configurações do Módulo"
                >
                  <mat-icon>settings</mat-icon>
                </button>

                <mat-menu #connectionMenu="matMenu">
                  <button
                    *ngFor="let option of getPossibleConnections(module, i)"
                    (click)="toggleConnection(module, option.id)"
                    mat-menu-item
                  >
                    <mat-icon>{{ isConnected(module, option.id) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                    <span>{{ option.name }}</span>
                  </button>
                </mat-menu>
                <button
                  *ngIf="getPossibleConnections(module, i).length > 0"
                  type="button"
                  mat-icon-button
                  [matMenuTriggerFor]="connectionMenu"
                  matTooltip="Definir Rotas Adicionais"
                >
                  <mat-icon>fork_right</mat-icon>
                </button>

                <button
                  type="button"
                  (click)="removeModule(module)"
                  mat-icon-button
                  color="warn"
                  matTooltip="Remover Módulo"
                >
                  <mat-icon>remove_circle_outline</mat-icon>
                </button>
              </div>

              <div
                *ngIf="hasUnmetDependencies(module)"
                class="mt-1 px-3 py-1 bg-yellow-50 border border-yellow-300 rounded text-xs text-yellow-700 flex items-center gap-1"
              >
                <mat-icon class="text-sm">warning</mat-icon>
                Dependências ausentes: {{ getMissingDependencyNames(module).join(', ') }}
              </div>
            </div>
          </div>
          <div *ngIf="modules.length === 0" class="text-center text-xs text-gray-400 py-4">
            Nenhum módulo adicionado
          </div>
        </div>
      </div>

      <div class="col-span-1">
        <h3 class="font-bold text-chathams-blue mb-4">Módulos Disponíveis</h3>
        <div class="flex flex-col gap-2 max-h-[300px] overflow-y-auto">
          <div
            *ngFor="let module of availableModules"
            class="bg-white hover:bg-iceberg p-3 flex items-center border justify-between border-iceberg rounded-md"
          >
            <span class="font-medium text-md text-chathams-blue">{{ module.name }}</span>
            <button
              type="button"
              (click)="addModule(module)"
              mat-mini-fab
              class="bg-chathams-blue"
              matTooltip="Adicionar Módulo ao Fluxo"
            >
              <mat-icon class="text-white">add</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <app-module-setting-modal
      *ngIf="showConfigModal && selectedModuleId"
      [moduleId]="selectedModuleId"
      [companyId]="formSetup.get('companyId')?.value"
      [initialConfig]="getModuleConfigForModal()"
      (closed)="showConfigModal = false"
      (save)="handleModuleConfig($event)"
    >
    </app-module-setting-modal>

    <div class="form-group flex items-center justify-center">
      <button
        *isAllowed="[ERoleAdminString.Admin, 'setup.create']"
        (click)="saveSetup()"
        class="w-80 h-9 btn btn--secondary"
      >
        + Salvar novo setup
      </button>
    </div>
  </form>
</app-dialog>
